import React from "react";
import { useTranslation } from "react-i18next";

import PiConfirmationDialog from "../../components/PiConfirmationDialog";

interface ClearOnboardingDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Asks before clearing onboarding progress, and names what goes.
 *
 * The action used to be an unlabelled "Reset" button that fired on the first
 * click. It is the only destructive control in the settings dialog, and what
 * it destroys is invisible (stored progress), so the list matters more than
 * the warning does.
 */
export default function ClearOnboardingDialog(props: ClearOnboardingDialogProps) {
  const { t } = useTranslation();

  const items = ["tours", "resume", "hints", "welcome"] as const;

  const text = (
    <span className="flex flex-col gap-[10px]">
      <span>{t("onboarding.clear.body")}</span>
      <ul className="!text-left flex flex-col gap-[4px] text-[13px] leading-[18px] text-creator-text list-disc pl-[18px]">
        {items.map((item) => (
          <li key={item} className="!text-left">
            {t("onboarding.clear.item." + item)}
          </li>
        ))}
      </ul>
      <span className="!text-[12px] !leading-[16px] text-creator-text-soft">
        {t("onboarding.clear.keeps")}
      </span>
    </span>
  );

  return (
    <PiConfirmationDialog
      open={props.open}
      onClose={props.onClose}
      title={t("onboarding.clear.title")}
      text={text}
      onConfirm={props.onConfirm}
      confirmText={t("onboarding.clear.confirm")}
      cancelText={t("onboarding.clear.cancel")}
      confirmButtonVariant="piRed"
      /* The shell positions its footer against the bottom edge, so the height
         has to clear four bullets plus the German translation. */
      height="420px"
    />
  );
}
